// extracted by mini-css-extract-plugin
module.exports = {"container":"rolesMatrix_container__1uTMS","tabs":"rolesMatrix_tabs__26Yaj","rolesList":"rolesMatrix_rolesList__2O8q-"};